import { connect } from 'react-redux'
import { compose, setDisplayName, withHandlers } from 'recompose'
import { currentBlockSizeSelector, sectionsSelector } from '../../../store/selectors/boardSelectors'
import { push } from 'react-router-redux'
import {
  embedModeSelector,
  modeSelector
} from '../../../store/selectors/selectors'
import getUrl from '../../../utils/getUrl'

export default compose(
  connect(
    (state, { block }) => {
      const currentBlockSize = currentBlockSizeSelector(state)
      const sections = sectionsSelector(state)
      const { width, height } = currentBlockSize || {}
      return {
        width,
        height,
        backgroundColor: sections[block.section].color,
        mode: modeSelector(state),
        embedMode: embedModeSelector(state)
      }
    },
    { push }
  ),
  withHandlers({
    backToBoard: ({ block, board, embedMode, push }) => () => {
      push(getUrl(board, { embedMode }), {
        scrollTo: block.id
      })
    }
  }),
  setDisplayName('BlockViewContainer')
)
